import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link, useParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function DrugFlow(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [drug, setDrug] = useState({ drug: '' });
  const [mode, setMode] = useState({ mode: '' });
  const [mode1, setMode1] = useState({ mode1: '' });
  const [rows, setRows] = useState([]);
  const [rows1, setRows1] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [combinedData1, setCombinedData1] = useState([]);
  const [viewPharmData, setViewPharmData] = useState([]);
  const [viewPharmData1, setViewPharmData1] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};

const handleUser = (event) => {
    const selectedProduct = event.target.value;
    setDrug(selectedProduct);
  };

  const handleMode = (event) => {
      setMode({
        ...mode,
        mode: event.target.value
      });
    };
    const handleMode1 = (event) => {
      setMode1((prevState) => ({
        ...prevState,
        mode1: event.target.value
      }));
    };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate, mode]);


function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}all-pharm-sale-gst/?start_date=${startDateString}&end_date=${endDateString}&mode=${mode.mode}&status=1`;

  axios.get(url)
    .then(response => {
      const filteredData = response.data.filter(item => item.mode !== 'Indent');
      setCombinedData(filteredData);
      setRows(filteredData);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
}

const getRowId = (row) => `${row.id}-${row.product}`;

  const columns = [

    { field: 'add_date_date', headerName: 'Date', width: 120 },
    { field: 'patient', headerName: 'Patient', width: 150 },
    { field: 'mode', headerName: 'Mode', width: 80 },
    {
      field: 'sale_id',
      headerName: 'Invoice No',
      renderCell: (params) => {
        let invoiceLink = '';
        if (params.row.sale_type === 'IndentBill') {
          invoiceLink = `/pharm-invoice-indent/${params.row.sale_id}`;
        } else {
          invoiceLink = `/pharm-invoice-other/${params.row.sale_id}`;
        }
        return (
          <Link to={invoiceLink} target="_blank">
            {params.row.sale_id}
          </Link>
        );
      },
      width: 120
    },
    { field: 'product', headerName: 'Product', width: 250 },
    { field: 'qty', headerName: 'Qty', width: 80 },
    { field: 'batch', headerName: 'Batch', width: 100 },
    { field: 'schedule', headerName: 'Schedule', width: 120 },
    { field: 'expiry', headerName: 'Expiry', width: 120 },
    { field: 'gstPercent', headerName: 'CGST %', width: 80 },
    { field: 'gstPercent1', headerName: 'SGST %', width: 80 },

    { field: 'gstTotal', headerName: 'Drug Amount', width: 100 },
    { field: 'gstAmountTotal', headerName: 'CGST', width: 100 },
    { field: 'gstAmountTotal1', headerName: 'SGST', width: 100 },
    {
      field: 'netamount',
      headerName: 'Net Amount',
      width: 150,
    },
    { field: 'addedby', headerName: 'Cashier', width: 80 },
  ];

  const getTotal = (rows, field) => {
    return rows.reduce((totals, row) => {
      const value = parseFloat(row[field]);
      if (!isNaN(value)) {
        return totals + value;
      }
      return totals;
    }, 0);
  };

  const Footer = ({ rows }) => {
    const totalDrugAmount = getTotal(rows, 'gstTotal');
    const totalTotAmount = getTotal(rows, 'netamount');
    const totalGstAmount = getTotal(rows, 'gstAmountTotal');
    const totalGstAmount1 = getTotal(rows, 'gstAmountTotal1');

    return (
      <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '8px' }}>
        <div>Total</div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div>{totalDrugAmount?.toFixed(2)}</div>
        <div>{totalGstAmount?.toFixed(2)}</div>
        <div>{totalGstAmount1?.toFixed(2)}</div>
        <div>{totalTotAmount?.toFixed(2)}</div>
      </div>
    );
  };

function transformData1(data) {
  let transformedData1 = [];

  data.forEach((row1, rowIndex1) => {
    if (row1.product && row1.gstamount) {
      const products = row1.product.split(',').map(item => item.trim());
      const gstAmounts = row1.gstamount.split(',').map(item => item.trim());
      const batches = row1.batch.split(',').map(item => item.trim());
      const netAmounts = row1.netamount.split(',').map(item => item.trim());
      const expirys = row1.expiry.split(',').map(item => item.trim());
      const gstg = row1.cgst.split(',').map(item => item.trim());
      const totQtys = row1.totqty.split(',').map(item => item.trim());

      products.forEach((product, index) => {
        if (index < gstAmounts.length && index < batches.length && index < netAmounts.length && index < totQtys.length && index < expirys.length && index < gstg.length ) {
          const netAmount = netAmounts[index];
          const gstAmount = gstAmounts[index];

          const gstTotalg = (netAmount - gstAmount).toFixed(2);
          const gstAmountTotalg = gstAmount / 2;

          let newRow = {
            grn_date_date: row1.grn_date_date, // Assuming these fields are consistent across the row
            type: row1.type,
            dist__name: row1.dist__name,
            productg: product,
            gstamount: gstAmounts[index],
            batchg: batches[index],
            netamountg: netAmounts[index],
            totqty: totQtys[index],
            grn_no: row1.grn_no,
            expiryg: expirys[index], // Assuming expiry is constant per row
            gstPercentg: gstg[index],
            gstPercentg1: gstg[index],
            gstTotalg: gstTotalg,
            gstAmountTotalg: gstAmountTotalg,
            gstAmountTotalg1: gstAmountTotalg,
            invoice: row1.invoice,
          };

          transformedData1.push(newRow);
        } else {
          console.error(`Mismatched product and gstamount/batch/netamount/totqty length at row ${rowIndex1}:`, row1);
        }
      });
    } else {
      console.error(`Missing product or gstamount at row ${rowIndex1}:`, row1);
    }
  });

  return transformedData1;
}

useEffect(() => {
  fetchData1();
}, [startDate, endDate, mode1]);

useEffect(() => {
  if (combinedData1.length > 0) {
    setRows1(combinedData1);
  }
}, [combinedData1]);

function fetchData1() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url1 = `${baseUrl}all-pharm-grn/?start_date=${startDateString}&end_date=${endDateString}&mode=${mode1.mode1}&status=1`;

  axios.get(url1)
    .then(response1 => {
      const transformedData1 = transformData1(response1.data);
      setCombinedData1(transformedData1);
      setRows1(transformedData1);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
}

const columns1 = [
  { field: 'grn_date_date', headerName: 'Date', width: 100 },
  { field: 'type', headerName: 'Payment Mode', width: 120 },
  { field: 'dist__name', headerName: 'Distributor', width: 220 },
  {
    field: 'productg',
    headerName: 'Product',
    width: 250,
  },
  {
    field: 'totqty',
    headerName: 'QTY',
    width: 30,
  },
  {
    field: 'grn_no',
    headerName: 'GRN No',
    renderCell: (params) => {
      let invoiceLink = '';
      invoiceLink = `/grn-invoice/${params.row.grn_no}`;
      return (
        <Link to={invoiceLink} target="_blank">
          {params.row.grn_no}
        </Link>
      );
    },
    width: 120
  },
  { field: 'batchg', headerName: 'Batch', width: 100 },
  { field: 'expiryg', headerName: 'Expiry', width: 120 },
  { field: 'gstPercentg', headerName: 'CGST %', width: 80 },
  { field: 'gstPercentg1', headerName: 'SGST %', width: 80 },
  { field: 'gstTotalg', headerName: 'Drug Amount', width: 100 },
  { field: 'gstAmountTotalg', headerName: 'CGST', width: 100 },
  { field: 'gstAmountTotalg1', headerName: 'SGST', width: 100 },
  {
    field: 'netamountg',
    headerName: 'Net Amount',
    width: 120,
  },
  { field: 'invoice', headerName: 'Invoice', width: 100 },
];

// Add your rendering logic here

const getRowId1 = (row1, index) => `${row1.grn_no}-${row1.product}-${row1.totqty}-${row1.batchg}-${index}`;

  const today = new Date();

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Drug Flow Report </h3>
      <div className="row">
        <div className="col-md-3">
            <label className="control-label">Select Date</label>
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText={'Please select From date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderText={'Please select To date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>
            <div className="col-md-3">
            <div className="mb-4 mt-4 form-control">
              <label htmlFor="mode" className="form-label">Search by Sales Mode</label>
              <select name="mode" id="mode" value={mode.mode} className="form-control"
                onChange={(event) => handleMode(event)}>
                <option value="">Select Sales Mode</option>
                <option value="cash">Cash</option>
                <option value="card">Card</option>
                <option value="creditpay">Credit Payment</option>
                <option value="advance">Advance</option>
                <option value="UPI">UPI</option>
              </select>
            </div>
            </div>
            <div className="col-md-3">
            <div className="mb-4 mt-4 form-control">
              <label htmlFor="mode1" className="form-label">Search by Purchase Mode</label>
              <select name="mode1" id="mode1" value={mode1.mode1} className="form-control"
                onChange={(event) => handleMode1(event)}>
                <option value="">Select Purchase Mode</option>
                <option value="CreditPurchase">Credit Purchase</option>
                <option value="CashPurchase">Cash Purchase</option>
              </select>
            </div>
            </div>
      </div>

  {!isLoading && combinedData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
        <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> View Drug Wise Sales</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            getRowId={getRowId}
            rows={rows}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,

            }}
            autoHeight
          />

        </div>
      ) : (
        <></>
      )}
      {!isLoading && rows1.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }} className="mt-5">
        <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> View Drug Wise GRN</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            getRowId={getRowId1}
            rows={rows1}
            columns={columns1}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,

            }}
            autoHeight
          />
        </div>
      ) : (
        <></>
      )}
    </section>
  )
}

export default DrugFlow;
